import { RootState } from "state/store";
import {
  BaseQueryApi,
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  createApi,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";
import { logOut } from "state/reducers/AuthSlice";
import { PURGE } from "redux-persist";

const baseQueryWithReauth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args: string | FetchArgs,
  api: BaseQueryApi,
  extraOptions: {}
) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    api.dispatch(logOut());
    api.dispatch({ type: PURGE, key: "auth", result: () => null });
    window.location.href = `${process.env.REACT_APP_RETURN_URL}`;
  }
  return result;
};

const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_BASE_API}`,

  prepareHeaders: async (headers, { getState }) => {

    const waitForToken = () => {
      return new Promise((resolve, reject) => {
        let checkCount = 0;
        const checkToken = () => {
          const token = (getState() as RootState).auth.token;
          if (token) {
            resolve(token)
          } else {
            checkCount = checkCount + 1;
            if (checkCount > 10) {
              reject();
            } else {
              setTimeout(checkToken, 100)
            }
          }
        }
        checkToken();
      })
    }

    try {
      const token = await waitForToken();
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
        return headers;
      }
    } catch (err: any) { }

  },
});

export const api = createApi({
  reducerPath: "api",
  tagTypes: [
    "Home",
    "Practice",
    "StudyPlanner",
    "StudyPlannerDeleteEvent",
    "TopicFocus",
    "StudyPlannerPostForm",
    "StudyPlannerUpdateEvent",
    "Coursework",
    "StudyPlannerAdditionalItems",
    "OverallProgress",
    "SelfPacedOverallProgress",
    "SelfPacedCoursework",
    "SelfPacedHome",
    "SelfPacedTopicFocus",
    "OnBoardingTour",
    "ThemePreference",
    "CourseIndex",
    "AllNotifications",
    "UnreadNotificationsCount",
  ],
  baseQuery: baseQueryWithReauth,
  // Ensure data is refreshed across navigation/focus changes
  refetchOnReconnect: true,
  keepUnusedDataFor: 0,
  endpoints: () => ({}),
});
